<template>
    <div class="share_doc">
		<el-dialog :visible.sync="shareVisible" width="780px" :close-on-click-modal="false" :show-close="false">
			<div class="dialog_title" slot="title">
				<div class="title_text">分享文档</div>
				<div class="close_btn" @click="shareVisible = false"><img class="close_icon" src="../views/img/img_icon_51.png" alt="">关闭</div>
			</div>
			<div class="dialog_content">
                <div class="link_condition">
                    <div class="share_link condition_item">
                        <div class="link_wrap">
                            <div class="link_text">{{ share_link }}</div>
                            <div class="link_btn" @click="changeShareLink">换一换</div>
                        </div>
                        <button @click="copytext" class="copy_btn">复制链接</button>
                    </div>
                    <div class="need_password condition_item">
                        <div class="password_label">开启访问密码，需要输入密码才可访问<el-input v-show="need_password" v-model="password" class="password" clearable @blur="blurPwd"></el-input></div>
                        <el-switch v-model="need_password" active-color="#07c160" inactive-color="#b3b3ba" @change="changePwd"></el-switch>
                    </div>
                    <div class="validity condition_item">
                        <div class="password_label">设置文档分享有效期，不设置默认为一天</div>
                        <el-radio-group v-model="expired_day" @change="redioChange" size="small">
                            <el-radio-button :label="3">三天</el-radio-button>
                            <el-radio-button :label="7">七天</el-radio-button>
                            <el-radio-button :label="15">十五天</el-radio-button>
                            <el-radio-button :label="0">永久</el-radio-button>
                        </el-radio-group>
                    </div>
                </div>
                <div class="share_notice">
                    <div class="notice_list">
                        <div class="notice_label">懒人办公文档分享规范：</div>
                        1、不允许违反法律法规和相关政策的行为及内容<br/>
                        2、不允许宣扬不良价值观<br/>
                        3、不允许发布谣言或不实内容<br/>
                        4、不允许诱导低俗、涉黄等内容<br/>
                        5、不允许不文明用语或引人不适或反感。。<br/>
                    </div>
                    <div class="notice_warn">如分享的内容违反规范，将对账号封号处理！</div>
                </div>
            </div>
		</el-dialog>
    </div>
</template>
<script type="text/ecmascript-6">
    export default {
        data() {
            return {
                shareVisible:false,
                share_link:"",
                need_password:false,
                password:"",
                enable_pwd:0,
                expired_day:1,
                article_id:0,
                share:{}
            }
        },
        created() {
        
        },
        methods: {
            show(article_id){
                this.article_id = article_id
                
                this.$http.get(`/front/aixz/article/share/`,{params:{article_id:this.article_id}}).then(res =>{
                    if(res.status=='200'){
                        this.share = res.data
                        this.share_link = MAIN_URLROOT +"/share/doc/?code="+ this.share.share_code
                        if(this.share.password){
                            
                            this.password = this.share.password
                            this.enable_pwd = this.share.enable_pwd
                            this.need_password = this.enable_pwd == 1 ? true:false
                        }
                        this.expired_day = this.share.expired_day + ""
                        this.shareVisible = true;
                    }
                })
            },
            copytext () {
                const el = document.createElement('textarea')
                el.setAttribute('readonly', 'readonly')
                el.style.position = 'absolute'
                el.style.left = '-9999px'
                el.value = this.share_link;
                document.body.appendChild(el)
                el.select()
                document.execCommand('copy')
                document.body.removeChild(el)
                this.$toast("复制成功");
            },
            blurPwd(){
                if(!this.password){
                    this.$message({
                        message: "请设置访问密码",
                        type: 'error'
                    });
                    return
                }
                this.$http.post(`/front/aixz/article/share/`,{article_id:this.article_id, expired_day:this.expired_day, enable_pwd:this.enable_pwd, password:this.password}).then(res =>{
                    if(res.status=='200'){
                        this.$toast("设置成功");
                    }
                }).catch(res => {
                    this.$message({
                        message: res.result,
                        type: 'error'
                    });
                })
            },
            changePwd(val){
                // if(val && !this.password){
                //     this.$message({
                //         message: "请设置访问密码",
                //         type: 'error'
                //     });
                //     this.need_password = false
                //     return
                // }
                this.enable_pwd = val ? 1:0
                this.$http.post(`/front/aixz/article/share/`,{article_id:this.article_id, expired_day:this.expired_day, enable_pwd:this.enable_pwd, password:this.password}).then(res =>{
                    if(res.status=='200'){
                        this.$toast("设置成功");
                    }
                }).catch(res => {
                    // this.$message({
                    //     message: res.result,
                    //     type: 'error'
                    // });
                })
            },
            redioChange(val){
                this.expired_day = val
                this.$http.post(`/front/aixz/article/share/`,{article_id:this.article_id, expired_day:this.expired_day, enable_pwd:this.enable_pwd, password:this.password}).then(res =>{
                    if(res.status=='200'){
                        this.$toast("设置成功");
                    }
                })
            },
            changeShareLink(){
                this.$http.put(`/front/aixz/article/share/`,{article_id:this.article_id}).then(res =>{
                    if(res.status=='200'){
                        this.$toast("更换成功");
                        this.share = res.data
                        this.share_link = MAIN_URLROOT +"/share/doc/?code="+ this.share.share_code
                        if(this.share.password){
                            
                            this.password = this.share.password
                            this.enable_pwd = this.share.enable_pwd
                            this.need_password = this.enable_pwd == 1 ? true:false
                        }
                        this.expired_day = this.share.expired_day + ""
                    }
                })
            }
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .dialog_content{
        padding: 30px 30px 0;
        .link_condition{
            border-bottom: 1px dashed #ccc;
            .condition_item{
                margin-bottom: 30px;
                &.share_link{
                    display: flex;
                    overflow: hidden;
                    .link_wrap{
                        flex-grow: 1;
                        margin-right: 13px;
                        height: 40px;
                        border-radius: 4px;
                        border: 1px solid #ddd;
                        padding: 0 12px;
                        line-height: 38px;
                        display: flex;
                        overflow: hidden;
                        .link_text{
                            flex-grow: 1;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            color: #999;
                            margin-right: 12px;
                        }
                        .link_btn{
                            flex-shrink: 0;
                            cursor: pointer;
                        }
                    }
                    .copy_btn{
                        width: 110px;
                        height: 40px;
                        border-radius: 4px;
                        background-color: #424242;
                        color: #fff;
                        border: none;
                    }
                }
                &.need_password{
                    display: flex;
                    justify-content: space-between;
                    height: 28px;
                    align-items: center;
                    .password_label{
                        flex-grow: 1;
                        .password{
                            display: inline-block;
                            width: 100px;
                            height: 28px;
                            text-align: center;
                            color: #999;
                            // border-radius: 4px;
                            // border: 1px solid #ddd;
                            line-height: 26px;
                            margin-left: 16px;
                        }
                        >>> .el-input__inner{
                            line-height: 36px;
                            height: 36px;
                        }
                    }
                }
                &.validity{
                    display: flex;
                    align-items: center;
                    .password_label{
                        margin-right: 16px;
                    }
                }
            }
        }
        .share_notice{
            display: flex;
            .notice_list{
                padding: 24px 0;
                color: #999;
                line-height: 30px;
                width: 415px;
                border-right: 1px dashed #ccc;
                .notice_label{
                    color: #666;
                    line-height: 26px;
                    margin-bottom: 8px;
                }
            }
            .notice_warn{
                color: #f00;
                flex-grow: 1;
                display: flex;
                align-items: center;
                justify-content: flex-end;
            }
        }
    }
</style>